module.exports = __webpack_public_path__ + "img/1d23d0377d605c0aa4cb8fd6e519ffb.371be052.png";